import PurchasesTable from './PurchasesTable';

export default PurchasesTable;
